import React from 'react';
import { FadeIn } from './FadeIn';
export function WhyOthersFail() {
  return <section className="bg-white py-24 px-6" data-id="element-431">
      <div className="max-w-4xl mx-auto" data-id="element-432">
        <FadeIn data-id="element-433">
          <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-10 text-center" data-id="element-434">
            No es que los métodos no funcionen. Es que ninguno fue diseñado para
            tu bebé.
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-texto mb-16 max-w-3xl mx-auto" data-id="element-435">
          <FadeIn delay={0.1} data-id="element-436">
            <p data-id="element-437">
              <span className="font-bold text-azul-noche" data-id="element-438">
                Probaste el método de llanto controlado.
              </span>
              <br data-id="element-439" />
              Lo dejaste en la cuna, escuchaste el llanto, miraste el reloj, te
              prometiste aguantar 5 minutos — y entraste al cuarto a los 2
              minutos sintiéndote horrible.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-440">
            <p data-id="element-441">
              <span className="font-bold text-azul-noche" data-id="element-442">
                Probaste los consejos de tu mamá y tu suegra.
              </span>
              <br data-id="element-443" />
              Uno dijo que lo cargaras más. El otro dijo que lo cargaras menos.
              Ambos contradictorios. Ambos seguros de tener razón.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-444">
            <p data-id="element-445">
              <span className="font-bold text-azul-noche" data-id="element-446">
                Viste videos de YouTube a las 2am.
              </span>
              <br data-id="element-447" />
              Cada video con un método diferente, cada creadora con su propio
              sistema, ninguno te explicó por qué funciona ni cómo adaptarlo a
              la edad exacta de tu bebé.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-448">
            <p className="font-medium text-xl mt-8 text-azul-noche" data-id="element-449">
              El problema no eres tú. El problema es que las soluciones que
              existen fueron diseñadas sin tomar en cuenta tres cosas
              fundamentales:
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-450">
          <div className="overflow-x-auto pb-6" data-id="element-451">
            <table className="w-full min-w-[600px] border-collapse rounded-xl overflow-hidden shadow-sm border border-gray-200" data-id="element-452">
              <thead data-id="element-453">
                <tr className="bg-azul-noche text-white" data-id="element-454">
                  <th className="py-4 px-6 text-left font-serif text-lg font-medium w-1/3" data-id="element-455">
                    Lo que ignoran la mayoría de métodos
                  </th>
                  <th className="py-4 px-6 text-left font-serif text-lg font-medium w-2/3" data-id="element-456">
                    La realidad
                  </th>
                </tr>
              </thead>
              <tbody className="text-texto bg-white" data-id="element-457">
                <tr className="border-b border-gray-100" data-id="element-458">
                  <td className="py-5 px-6 font-bold bg-crema/30" data-id="element-459">
                    La edad específica del bebé
                  </td>
                  <td className="py-5 px-6" data-id="element-460">
                    Un bebé de 3 semanas necesita algo completamente diferente a
                    uno de 4 meses
                  </td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-461">
                  <td className="py-5 px-6 font-bold bg-crema/30" data-id="element-462">
                    El temperamento individual
                  </td>
                  <td className="py-5 px-6" data-id="element-463">
                    No todos los bebés responden igual al mismo estímulo
                  </td>
                </tr>
                <tr data-id="element-464">
                  <td className="py-5 px-6 font-bold bg-crema/30" data-id="element-465">
                    El agotamiento de la mamá
                  </td>
                  <td className="py-5 px-6" data-id="element-466">
                    Una estrategia que requiere voluntad de hierro a las 3am no
                    es una estrategia real
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-467">
          <div className="mt-12 bg-crema/50 p-6 rounded-xl border border-crema text-lg text-center max-w-3xl mx-auto" data-id="element-468">
            <p data-id="element-469">
              Lo que necesitabas — y lo que no existía hasta ahora en español,
              diseñado para mamás latinas, adaptado semana a semana — era un
              sistema que funcione{' '}
              <span className="font-bold text-azul-noche" data-id="element-470">
                con el cerebro de tu bebé, no contra él.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}